import React from 'react';
import { SingleDatePicker } from 'react-dates';
import { dateDisplayFormat, dateTransferFormat } from '../../../../webcommon/common/constants';
import { dateTimeToMoment } from '../../../../webcommon/common/helpers';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import datesPickerStyles from './DatePickerStyles.module.scss';
import defaultStyles from './CustomDropdown.module.scss';
import 'react-dates/initialize';

const CustomDatePicker = props => (
    <div className={ props.styles.dateWrapper }>
        <div className={ props.styles.dateTitle }>
            {props.title}
        </div>
        <div className={ datesPickerStyles['dates-wrapper'] }>
            <SingleDatePicker
                date={ props.date ? dateTimeToMoment(props.date) : null }
                onDateChange={ date => (date !== null
                    ? props.setDate(date.format(dateTransferFormat))
                    : props.setDate(null)) }
                displayFormat={ dateDisplayFormat }
                id="webJobsDatePicker"
                isOutsideRange={ () => false }
                numberOfMonths={ 1 }
                firstDayOfWeek={ 1 }
                showClearDate
                focused={ props.dateFocused }
                onFocusChange={ ({ focused }) => props.setDateFocused(focused) }
                small
                hideKeyboardShortcutsPanel
                appendToBody
            />
        </div>
    </div>
);

CustomDatePicker.propTypes = {
    date: PropTypes.string,
    dateFocused: PropTypes.bool,
    setDate: PropTypes.func,
    setDateFocused: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string
};

CustomDatePicker.defaultProps = {
    date: '',
    dateFocused: false,
    setDate: noop,
    setDateFocused: noop,
    styles: defaultStyles,
    title: ''
};

export default CustomDatePicker;
